import { useQuery } from "@apollo/client";

import SITE_GEOMETRY from "react-migration/domains/sites/apollo/li-api/queries/siteGeometry.gql";
import { routedClient } from "react-migration/lib/persistence/apollo";
import { ConstraintsCategory } from "react-migration/layouts/map/Constraints/types";
import { useDesignationsByGeometry } from "react-migration/domains/constraints/designation/hooks";

export const useZoningData = (siteId: string) => {
  const { loading: loadingGeometry, data: geometryData } = useQuery(SITE_GEOMETRY, {
    variables: { _id: siteId },
    client: routedClient,
  });

  const geometry = geometryData?.siteGeometry?.geometry;

  const { loading: loadingDesignations, designations } = useDesignationsByGeometry({
    geometry: geometry || null,
    rootCategories: [ConstraintsCategory.ZONING],
  });

  const loading = loadingDesignations || loadingGeometry;

  return { loading, designations };
};
